mutation checkDefaultSenderVerification($companyId: ID!) {
  defaultSender: checkDefaultSenderVerification(companyId: $companyId) {
    id
    isVerified
    fromEmail
    isAcknowledged
    name
  }
}
